import { render } from "./SectionCall.vue?vue&type=template&id=c8556e9c"
import script from "./SectionCall.vue?vue&type=script&lang=js"
export * from "./SectionCall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__